import {dataFetcher} from "../../services/dataGuetter/dataFetcher";


export function getAllLocationAuth():Promise<LocationAuth[]>{
    return dataFetcher(`get_locations_auth`)
}